var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 438,
    viewBox: "0 0 375 438",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M374.995 417.236C374.997 425.614 365.314 430.28 358.762 425.059L242 332H374.974L374.995 417.236Z",
    fill: "url(#paint0_linear_528_374)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 30C0 13.4315 13.4315 0 30 0H345C361.569 0 375 13.4315 375 30V345C375 361.569 361.569 375 345 375H30C13.4315 375 0 361.569 0 345V30ZM135.782 108.011C136.213 106.825 137.34 106.036 138.602 106.036L182.855 106.035C184.827 106.035 186.263 107.906 185.753 109.812L147.174 253.79C146.822 255.102 145.634 256.014 144.276 256.014H86.2812C84.1996 256.014 82.7507 253.946 83.4616 251.989L135.782 108.011ZM235.602 106.145C234.34 106.145 233.213 106.935 232.782 108.12L180.462 252.099C179.751 254.055 181.2 256.123 183.281 256.123H241.276C242.634 256.123 243.822 255.211 244.174 253.9L282.753 109.921C283.263 108.016 281.827 106.145 279.855 106.145L235.602 106.145Z",
    fill: "url(#paint1_linear_528_374)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_528_374",
    x1: 308.5,
    y1: 438,
    x2: 308.5,
    y2: 332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF70AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF70AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_528_374",
    x1: 44.5,
    y1: 19.5,
    x2: 325.5,
    y2: 375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.333333,
    stopColor: "#8A6BEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF70AC"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d2a61f2c2663f9dc28acec3c8c3ea31a.svg";
export { ForwardRef as ReactComponent };